export const getQueryString = (input: any): string =>
  Object.keys(input)
    .map((key: string): string | null => {
      return `${key}=${encodeURIComponent(input[key])}`
    })
    .join("&")
